import {
  Home,
  LayoutDashboard,
  CalendarDays,
  Users,
  Building2,
  Clapperboard,
  SlidersHorizontal,
  ListCheck,
  ListMusic,
  Video,
  ChartNoAxesColumn,
  UserPen,
  MonitorPlay
} from "lucide-react";
import {
  SidebarProvider,
  Sidebar,
  SidebarHeader,
  SidebarContent,
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarFooter,
  SidebarTrigger,
  SidebarGroupLabel,
  SidebarGroupContent,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Separator } from "@/components/ui/separator";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "./auth";
import { useTranslate } from "@/helper/translate";

function SidebarToggleButton() {
  const { state } = useSidebar();

  return (
    <SidebarTrigger
      className={`fixed z-30 text-gray-400 transition-all duration-200 dark:hover:text-orange-300 hover:text-sky-700 bg-gray-200 dark:bg-zinc-900 hover:bg-gray-200 rounded-r-md rounded-l-[0px] top-1/2 -translate-y-1/2 w-[18px] h-[50px] max-md:!left-0 ${state === "expanded" ? "left-[13rem]" : "left-0"}`}
    />
  );
}

export function RmSidebar() {
  const location = useLocation();
  const { linkedCustomerId } = useAuth();
  const { translate } = useTranslate();

  const sidebarItems =
    linkedCustomerId == "Admin"
      ? [
          {
            title: translate("ui.dashboard"),
            url: "/dashboard",
            icon: LayoutDashboard,
          },
          {
            title: translate("ui.bookings"),
            url: "/bookings",
            icon: CalendarDays,
          },
          {
            title: translate("ui.customers"),
            url: "/customer",
            icon: Users,
          },
          // {
          //   title: "Sites",
          //   url: "/sites",
          //   icon: Building2,
          // },
          {
            title: translate("ui.spots"),
            url: "/spots",
            icon: Video,
          },
          {
            title: translate("ui.orders"),
            url: "/orders",
            icon: ListCheck,
          },
          {
            title: translate("ui.playlists"),
            url: "/playlists",
            icon: Clapperboard,
          },
          {
            title: translate("ui.occupancy"),
            url: "/occupancy",
            icon: ChartNoAxesColumn,
          },
          {
            title: translate("ui.users"),
            url: "/users",
            icon: UserPen,
          },
           {
            title: translate("ui.monitor"),
            url: "/monitor",
            icon: MonitorPlay,
          },
        ]
      : [
          {
            title: translate("ui.bookings"),
            url: "/bookings",
            icon: CalendarDays,
          },
          {
            title: translate("ui.spots"),
            url: "/spots",
            icon: Video,
          },
          {
            title: translate("ui.orders"),
            url: "/orders",
            icon: ListCheck,
          },
        ];

  return (
    <SidebarProvider className="relative">
      {/* TODO: Herausfinden woher --header-height kommt? */}
      {/* <Sidebar className="top-[--header-height] !h-[calc(100svh-var(--header-height))]"> */}
      <Sidebar className="top-[60px] !h-[calc(100svh-60px)]">
        {/* <SidebarHeader>
          <div className="flex gap-1">
            <div>
              <Avatar>
                <AvatarImage src="https://github.com/shadcn.png" />
                <AvatarFallback>CN</AvatarFallback>
              </Avatar>
            </div>
            <div className="text-sm">
              <p className="font-bold">Sally Saler</p>
              <p className="text-gray-500">Administrator</p>
            </div>
          </div>
        </SidebarHeader> */}

        {/* <Separator /> */}

        <SidebarContent>
          <SidebarGroup>
            <SidebarGroupLabel>{ translate("ui.menu") }</SidebarGroupLabel>
            <SidebarGroupContent>
              <SidebarMenu>
                {sidebarItems.map((item) => {
                  const isActive =
                    location.pathname === item.url ||
                    location.pathname.startsWith(item.url + "/");

                  return (
                    <SidebarMenuItem key={item.title}>
                      <SidebarMenuButton asChild isActive={isActive}>
                        <Link to={item.url}>
                          <item.icon />
                          <span>{item.title}</span>
                        </Link>
                      </SidebarMenuButton>
                    </SidebarMenuItem>
                  );
                })}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        </SidebarContent>

        <SidebarFooter />
      </Sidebar>
      <SidebarToggleButton />
      {/* <SidebarTrigger /> */}
    </SidebarProvider>
  );
}